import { render, staticRenderFns } from "./BillReceivableStatusChip.vue?vue&type=template&id=76edc33b&"
import script from "./BillReceivableStatusChip.vue?vue&type=script&lang=js&"
export * from "./BillReceivableStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports